import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Workshops from "./pages/Workshops";
import WorkshopDetail from "./pages/WorkshopDetail";
import Access from "./pages/Access";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import Wejscie from "./pages/Wejscie";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import VerifyEmail from "./pages/VerifyEmail";
import ResetPassword from "./pages/ResetPassword";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isKiosk = location.pathname.startsWith("/wejscie");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={<Admin />} />
      </Routes>
    );
  }

  if (isKiosk) {
    return (
      <Routes>
        <Route path="/wejscie" element={<Wejscie />} />
      </Routes>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/warsztaty" element={<Workshops />} />
        <Route path="/warsztaty/:id" element={<WorkshopDetail />} />
        <Route path="/dostep" element={<Access />} />
        <Route path="/o-nas" element={<About />} />
        <Route path="/regulamin" element={<Terms />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/weryfikacja" element={<VerifyEmail />} />
        <Route path="/reset-hasla" element={<ResetPassword />} />
      </Routes>
    </PublicLayout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
